export default {
  driver_management: ['driver_management'],
  driver_add: ['driver_add'],
  driver_edit: ['driver_edit'],
  driver_status: ['driver_edit'],
  driver_delete: ['driver_delete'],
  driver_archive: ['driver_archive'],
  driver_restore: ['driver_restore'],
  driver_document_management: ['driver_document_management'],
  driver_document_edit: ['driver_document_edit'],
  driver_document_delete: ['driver_document_delete'],
  driver_document_add: ['driver_document_add'],
  driver_document_archive: ['driver_document_archive'],
  driver_document_restore: ['driver_document_restore'],
  driver_license_management: ['driver_license_management'],
  driver_license_add: ['driver_license_add'],
  driver_license_edit: ['driver_license_edit'],
  driver_license_delete: ['driver_license_delete'],
  driver_license_archive: ['driver_license_archive'],
  driver_license_restore: ['driver_license_restore']
}
